module.exports = __webpack_public_path__ + "img/mon_256.04bd016f.png";